import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=82eaa1f4&scoped=true&"
import script from "./FormText.vue?vue&type=script&lang=js&"
export * from "./FormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eaa1f4",
  null
  
)

export default component.exports